import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { CreateEventPayload, EventUploadUrlData } from '../types';

export function useCreateEvent() {
  const queryClient = useQueryClient();
  const {
    data: uploadUrlData,
    isFetching,
    refetch: refetchUploadUrl,
  } = useApiQuery<EventUploadUrlData>('/events/upload-url', {
    queryKey: ['eventUploadUrl'],
    initialData: null,
  });

  const {
    data: uploadIdleStateUrlData,
    refetch: refetchIdleStateUploadUrl,
    isFetching: isFetchingIdleStateUploadUrl,
  } = useApiQuery<EventUploadUrlData>(
    `/events/idle-state-video-reupload-url/${uploadUrlData?.eventId}`,
    {
      queryKey: ['eventIdleStateUploadUrl'],
      initialData: null,
      enabled: !!uploadUrlData?.eventId,
    }
  );

  const createEventMutation = useApiMutation<CreateEventPayload>(
    '/events',
    {
      method: 'POST',
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['events'] });
      },
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    uploadUrlData: {
      ...uploadUrlData,
      idleStateVideoPublicUrl: uploadIdleStateUrlData?.signedUrl,
    },
    refetchUploadUrl,
    createEventMutation,
    refetchIdleStateUploadUrl,
    isFetching: isFetching || isFetchingIdleStateUploadUrl,
  } as const;
}
